import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getOneLabResult } from "../../../../../../../../store/actions";
import { useParams, useHistory } from "react-router-dom";
import View from "../../Repeated-Component/View";
import { useToast } from "@chakra-ui/react";

const ViewOneLabResult = ({ getOneLabResult, OneLabResult, patient }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [LabResult, setLabResult] = useState(null);
  const { medicalId } = useParams();
  const toast = useToast();
  let history = useHistory();

  useEffect(() => {
    if (medicalId && patient) {
      getOneLabResult(medicalId, toast, history, patient.id);
    }
  }, []);

  useEffect(() => {
    const { loading, error, data } = OneLabResult;
    setLoading(loading);
    setError(error);
    if (data) {
      setLabResult(data);
    }
  }, [OneLabResult]);
  const renderView = () => {
    return (
      <View
        loading={loading}
        error={error}
        headerText="View Lab Result"
        one={LabResult}
        history={history}
      />
    );
  };
  return renderView();
};

const mapStateToProps = (state) => {
  return {
    OneLabResult: state.OneLabResult,
  };
};
export default connect(mapStateToProps, { getOneLabResult })(ViewOneLabResult);
